var map = {
	"./city/new/level/Bronze.jpg": 18274,
	"./city/new/level/Diamond.jpg": 70729,
	"./city/new/level/Emerald.jpg": 78872,
	"./city/new/level/Gold.jpg": 12884,
	"./city/new/level/Platinum.jpg": 65761,
	"./city/new/level/Ruby.jpg": 47018,
	"./city/new/level/Silver.jpg": 23491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28057;